/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_RecommendInputs */

const id_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Anda merekomendasikan produk ini?`)
};

const ms_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adakah anda mengesyorkan produk ini?`)
};

const da_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vil du anbefale dette produkt?`)
};

const de_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Würden Sie dieses Produkt empfehlen?`)
};

const en_us2_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you recommend this product?`)
};

const es_es2_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Recomendarías este producto?`)
};

const es_mx2_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Recomendarías este producto?`)
};

const fil_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Irerekomenda mo ba ang produktong ito?`)
};

const fr_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommandez-vous ce produit ?`)
};

const it_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccomanderesti questo prodotto?`)
};

const hu_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlanád ezt a terméket?`)
};

const nl_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zou je dit product aanbevelen?`)
};

const no_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vil du anbefale dette produktet?`)
};

const pl_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy poleciłbyś ten produkt?`)
};

const pt_br2_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you recommend this product?`)
};

const pt_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendaria este produto?`)
};

const ro_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ai recomanda acest produs?`)
};

const fi_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suosittelisitko tätä tuotetta?`)
};

const sv_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skulle du rekommendera denna produkt?`)
};

const vi_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn có đề xuất sản phẩm này không?`)
};

const tr_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu ürünü önerir misiniz?`)
};

const cs_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doporučili byste tento produkt?`)
};

const bg_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бихте ли препоръчали този продукт?`)
};

const ru_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Порекомендовали бы вы этот продукт?`)
};

const uk_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чи рекомендуєте ви цей продукт?`)
};

const ar_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل توصي بهذا المنتج؟`)
};

const hi_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप अनुशंसा करेंगे?`)
};

const th_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณจะแนะนำผลิตภัณฑ์นี้หรือไม่?`)
};

const ja_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この製品をおすすめしますか？`)
};

const zh_cn2_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you recommend this product?`)
};

const zh_hant1_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you recommend this product?`)
};

const ko_forms_review_recommend = /** @type {(inputs: Forms_Review_RecommendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you recommend this product?`)
};

/**
* | output |
* | --- |
* | "Would you recommend this product?" |
*
* @param {Forms_Review_RecommendInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_recommend = /** @type {((inputs?: Forms_Review_RecommendInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_RecommendInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_recommend(inputs)
	if (locale === "ms") return ms_forms_review_recommend(inputs)
	if (locale === "da") return da_forms_review_recommend(inputs)
	if (locale === "de") return de_forms_review_recommend(inputs)
	if (locale === "en-US") return en_us2_forms_review_recommend(inputs)
	if (locale === "es-ES") return es_es2_forms_review_recommend(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_recommend(inputs)
	if (locale === "fil") return fil_forms_review_recommend(inputs)
	if (locale === "fr") return fr_forms_review_recommend(inputs)
	if (locale === "it") return it_forms_review_recommend(inputs)
	if (locale === "hu") return hu_forms_review_recommend(inputs)
	if (locale === "nl") return nl_forms_review_recommend(inputs)
	if (locale === "no") return no_forms_review_recommend(inputs)
	if (locale === "pl") return pl_forms_review_recommend(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_recommend(inputs)
	if (locale === "pt") return pt_forms_review_recommend(inputs)
	if (locale === "ro") return ro_forms_review_recommend(inputs)
	if (locale === "fi") return fi_forms_review_recommend(inputs)
	if (locale === "sv") return sv_forms_review_recommend(inputs)
	if (locale === "vi") return vi_forms_review_recommend(inputs)
	if (locale === "tr") return tr_forms_review_recommend(inputs)
	if (locale === "cs") return cs_forms_review_recommend(inputs)
	if (locale === "bg") return bg_forms_review_recommend(inputs)
	if (locale === "ru") return ru_forms_review_recommend(inputs)
	if (locale === "uk") return uk_forms_review_recommend(inputs)
	if (locale === "ar") return ar_forms_review_recommend(inputs)
	if (locale === "hi") return hi_forms_review_recommend(inputs)
	if (locale === "th") return th_forms_review_recommend(inputs)
	if (locale === "ja") return ja_forms_review_recommend(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_recommend(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_recommend(inputs)
	return ko_forms_review_recommend(inputs)
});
export { forms_review_recommend as "forms.review.recommend" }